import Component from './image-uploader';

export default Component;

export {Image, UploadError} from './types';
